import {Component, Input, NgModule, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '../../directives/directives.module';

@Component({
    selector: 'app-page-intro',
    templateUrl: './page-intro.component.html',
    styleUrls: ['./page-intro.component.scss']
})
export class PageIntroComponent implements OnInit {
    @Input() backgroundImg: string;
    @Input() title: string;
    @Input() text: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}

@NgModule({
    declarations: [PageIntroComponent],
    exports: [
        PageIntroComponent
    ],
    imports: [
        CommonModule,
        DirectivesModule
    ]
})

export class PageIntroModule {
}
